import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const geographyApi = createApi({
  reducerPath: reducerPaths.geographyApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: () => ({
        url: `/countries`,
        method: "GET",
      }),
    }),
    getStates: builder.query({
      query: ({ countryId }) => ({
        url: `/states/${countryId}`,
        method: "GET",
      }),
    }),
    getCities: builder.query({
      query: ({ stateId }) => ({
        url: `/cities/${stateId}`,
        method: "GET",
      }),
    })
  }),
});

export const {
  useGetCountriesQuery,
  useGetStatesQuery,
  useGetCitiesQuery,
  useLazyGetCountriesQuery,
  useLazyGetStatesQuery,
  useLazyGetCitiesQuery
} = geographyApi;